import { Box, Chip, SxProps, Typography, useTheme } from '@mui/material'

import { IImpactConsumerScanItem } from 'src/types'

import { useCustomModal } from 'src/hooks'
import { AIVerifiedModal } from './ai-verified-modal'

interface IProps {
  data: IImpactConsumerScanItem[]
  aiVerifiedCount: number
  sx?: SxProps
}

export const AIVerifiedBanner = ({ data, aiVerifiedCount, sx }: IProps) => {
  const { handleClose, handleOpen, open } = useCustomModal()
  const theme = useTheme()

  return (
    <>
      <Box
        id="index__components-ai-verified-banner__box__l19"
        sx={{
          position: 'absolute',
          bottom: '-6px',
          right: '-12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'transform 200ms',
          willChange: 'transform',
          '&:hover': {
            transform: 'scale(0.9)',
          },
          '&:active': {
            transform: 'scale(0.9)',
          },
          ...sx,
        }}
        onClick={handleOpen}
        className="ai-verified-banner"
        zIndex={100}
      >
        <Chip
          id="index__components-ai-verified-banner__chip__l41"
          size="medium"
          className="count-chip"
          sx={{
            width: 'auto',
            height: '35px',
            borderRadius: '17.5px',

            display: 'flex',
            textAlign: 'center',
            backgroundColor: theme.palette.common.white,
            border: `2.5px solid ${theme.palette.primary.main}`,
            color: theme.palette.primary.main,
            '.MuiChip-label': {
              // p: '0px',
            },
          }}
          label={
            <Typography
              id="index__components-ai-verified-banner__typography__l59"
              sx={{ fontSize: '16px', fontWeight: 600 }}
            >
              {aiVerifiedCount}
            </Typography>
          }
        />
      </Box>

      <AIVerifiedModal
        handleClose={handleClose}
        open={open}
        data={data}
        aiVerifiedCount={aiVerifiedCount}
      />
    </>
  )
}
